import { NgRedux } from '@angular-redux/store';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Actions, IAppState } from '@app/core/redux/stores';
import { AuthTrackingService, ConfirmModalService, ModalService, ProxyService, SignOutService, ValidationService } from '@app/core/services';
import { LoggingService } from '@app/core/services/logging.service';
import { UpdateTrigger } from '@app/shared/components/validation-message';
import { ApiRoutes } from '@app/shared/models/configs/api.endpoints';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-delete-account-confirmation',
  templateUrl: './delete-account-confirmation.component.html',
  styleUrls: ['./delete-account-confirmation.component.less']
})
export class DeleteAccountConfirmationComponent implements OnInit {
  public deleteAccountForm: UntypedFormGroup;
  public disableDeleteAccountButton: boolean;
  public loading: boolean;
  private subscriptions = new Subscription();
  public errorMessage: string;
  updateTrigger: any = UpdateTrigger;
  constructor(private fb: UntypedFormBuilder,
    private modalService: ModalService,
    private confirmModalService: ConfirmModalService,
    private router: Router,
    private auth: AuthTrackingService,
    private signoutService: SignOutService,
    private ngRedux: NgRedux<IAppState>,
    private proxy: ProxyService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.createForm();
    this.deleteAccountForm.valueChanges.subscribe(() => {
      if (this.deleteAccountForm.valid) {
        this.disableDeleteAccountButton = false;
      } else {
        this.disableDeleteAccountButton = true;
      }
    });

    this.subscriptions.add(
      this.confirmModalService.btnEvent.subscribe(
        (data: string) => {
          if (data === 'customerCare') {
            this.router.navigateByUrl('/contact-us');
          }
        }
      )
    );
  }

  createForm() {
    this.deleteAccountForm = this.fb.group({
      confirmationText: new UntypedFormControl(null, [ValidationService.validateDeleteText])
    });
  }
  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }

  childClosed() {
    this.modalService.hideModal();
  }

  onTextChange() {
    this.errorMessage = '';
  }
  onSubmit() {
    this.loading = true;
    this.proxy.httpDelete(ApiRoutes.ACCOUNT,'').toPromise().then(() => {    
    this.signOutAndNavigate();
    }).catch(err => {
      this.logger.logError(err);
      this.modalService.hideModal();
      this.confirmModalService.show(
        '',
        'Oops, we had a problem deleting your account. Please try again.',
        '',
        'OK, Got It',
        '',
        '',
        true
      );
    });
  }
  private signOutAndNavigate() {
    this.auth.setSignedOutUserEmail();
    this.ngRedux.dispatch({ type: Actions.USERLOGGEDOUT });
    this.signoutService.logOut();
    this.router.navigateByUrl('/home/initiate-delete-account');
  }
}
